import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgWedgeDown = (props) => /* @__PURE__ */ _jsx("svg", {
	fill: "#000000",
	width: "800px",
	height: "800px",
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M11.178 19.569a.998.998 0 0 0 1.644 0l9-13A.999.999 0 0 0 21 5H3a1.002 1.002 0 0 0-.822 1.569l9 13z" })
});
export default SvgWedgeDown;
